import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";

import { DefaultCatchBoundary } from "~/components/default-catch-boundary";
import { DefaultNotFound } from "~/components/default-not-found";
import { routeTree } from "./routeTree.gen";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 2, // 2 minutes.
    },
  },
});

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: DefaultCatchBoundary,
  defaultNotFoundComponent: DefaultNotFound,
  scrollRestoration: true,
  defaultStructuralSharing: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// The OCPP onboarding hands the show-once connection token from the
// registration step to the instructions step through history state, so it
// survives client-side navigation but neither a refresh nor a shared URL.
declare module "@tanstack/history" {
  interface HistoryState {
    ocppAuthToken?: string;
  }
}
